import { render, staticRenderFns } from "./right-top.vue?vue&type=template&id=8354866a&"
import script from "./right-top.vue?vue&type=script&lang=js&"
export * from "./right-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports